import React from 'react';
import { FormControl, MenuItem, Select, type SelectChangeEvent, type SxProps, type Theme } from '@mui/material';
import { obsidianFilterMenuProps, obsidianFilterSelectSx } from './obsidianTableTheme';

export interface ObsidianDashboardFilterSelectProps<T extends string | number> {
    value: T;
    onChange: (value: T) => void;
    children: React.ReactNode;
    minWidth?: number | object;
    sx?: SxProps<Theme>;
    displayEmpty?: boolean;
}

export function ObsidianDashboardFilterSelect<T extends string | number>({
    value,
    onChange,
    children,
    minWidth = 140,
    sx,
    displayEmpty,
}: ObsidianDashboardFilterSelectProps<T>) {
    return (
        <FormControl size="small" sx={{ minWidth }}>
            <Select
                value={value}
                displayEmpty={displayEmpty}
                onChange={(e: SelectChangeEvent<T>) => onChange(e.target.value as T)}
                MenuProps={obsidianFilterMenuProps}
                sx={[obsidianFilterSelectSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
                {children}
            </Select>
        </FormControl>
    );
}

export { MenuItem as ObsidianFilterMenuItem };
